export default "__VITE_ASSET__fa8cb147__"